import * as Cesium from 'cesium';
import { showAlert } from "helper";
import styled from "styled-components";
import Accordion from "../../../Accordion";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux';
import AccordionItem from "../../../Accordion/AccordionItem";
import useProjectStore from "../../../../store-zustand/project"
import { CodeOutlined, DataObjectOutlined, FilterHdrOutlined, GrainOutlined, SatelliteOutlined, CloudUploadOutlined, PublicOutlined, GridViewOutlined, LayersOutlined } from "@mui/icons-material";

const AddAssetsBtn = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 90%;
  height: 50px;
  font-size: ${({ theme }) => theme.font.size.text.small};
  margin: 2.5rem auto;
  border: 1px dashed ${({ theme }) => theme.textColor.secondary} !important;
  border-radius: ${({ theme }) => theme.borderRadius.default};
  color: #a0a0a0;
  svg {
    width: 20px;
    height: 20px;
    margin-right: 24px;
  }

  &:hover {
    border: 1px dashed #E5E5E5 !important;
    color: #E5E5E5;

    svg {
      path {
        fill: #E5E5E5 !important;
      }
    }
  }
`;

const icons = {
  "3DTILES": <GrainOutlined />,
  "GLTF": <svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="24px" viewBox="0 0 24 24" width="24px" fill="#a8a8a8"><g><rect fill="none" height="24" width="24" x="0" y="0" /></g><g><g><path d="M3,4c0-0.55,0.45-1,1-1h2V1H4C2.34,1,1,2.34,1,4v2h2V4z" /><path d="M3,20v-2H1v2c0,1.66,1.34,3,3,3h2v-2H4C3.45,21,3,20.55,3,20z" /><path d="M20,1h-2v2h2c0.55,0,1,0.45,1,1v2h2V4C23,2.34,21.66,1,20,1z" /><path d="M21,20c0,0.55-0.45,1-1,1h-2v2h2c1.66,0,3-1.34,3-3v-2h-2V20z" /><path d="M19,14.87V9.13c0-0.72-0.38-1.38-1-1.73l-5-2.88c-0.31-0.18-0.65-0.27-1-0.27s-0.69,0.09-1,0.27L6,7.39 C5.38,7.75,5,8.41,5,9.13v5.74c0,0.72,0.38,1.38,1,1.73l5,2.88c0.31,0.18,0.65,0.27,1,0.27s0.69-0.09,1-0.27l5-2.88 C18.62,16.25,19,15.59,19,14.87z M11,17.17l-4-2.3v-4.63l4,2.33V17.17z M12,10.84L8.04,8.53L12,6.25l3.96,2.28L12,10.84z M17,14.87l-4,2.3v-4.6l4-2.33V14.87z" /></g></g></svg>,
  "TERRAIN": <FilterHdrOutlined />,
  "IMAGERY": <SatelliteOutlined />,
  "KML": <CodeOutlined />,
  "GEOJSON": <DataObjectOutlined />,
  "MATTERPORT": <svg width="18" height="18" viewBox="0 0 13 22" xmlns="http://www.w3.org/2000/svg" fill="#a8a8a8">
    <path d="M7.5 4C8.6 4 9.5 3.1 9.5 2C9.5 0.9 8.6 0 7.5 0C6.4 0 5.5 0.9 5.5 2C5.5 3.1 6.4 4 7.5 4ZM3.8 7.4L1 21.5H3.1L4.9 13.5L7 15.5V21.5H9V14L6.9 12L7.5 9C8.8 10.5 10.8 11.5 13 11.5V9.5C11.1 9.5 9.5 8.5 8.7 7.1L7.7 5.5C7.14 4.61 6.02 4.25 5.05 4.66L0 6.8V11.5H2V8.1L3.8 7.4Z" />
  </svg>,
  "WMS": <PublicOutlined />,
  "WMTS": <GridViewOutlined />,
  "TMS": <LayersOutlined />,
};

const Assets = (props) => {
  const dispatch = useDispatch();
  const { onAdd, onEdit } = props;
  const [assets, setAssets] = useState([]);
  const [visibilities, setVisibilities] = useState([]);
  const { getProjectAssets, project_id, deleteProjectAsset } = useProjectStore();
  const Hide3DTerrain = useSelector(state => state.settings.Hide3DTerrain);

  const getAssets = () => {
    getProjectAssets(project_id).then((response) => {
      if (response.assets) {
        setAssets(response.assets);
      }
    })
  }

  useEffect(() => {
    getAssets();
  }, [])

  const removeItem = (id) => {
    if (!window.assets || !window.assets[id]) return;

    const asset = window.assets[id];
    switch (asset.type) {
      case "3DTILES":
        window.MAIN_CESIUM_VIEWER.scene.primitives.remove(asset);
        break;
      case "IMAGERY":
      case "WMTS":
      case "WMS":
      case "TMS":
        window.MAIN_CESIUM_VIEWER.imageryLayers.remove(asset);
        break;
      case "TERRAIN":
        window.MAIN_CESIUM_VIEWER.terrainProvider = new Cesium.EllipsoidTerrainProvider();
        asset.show = false;
        break;
      case "GLTF":
        window.MAIN_CESIUM_VIEWER.entities.remove(asset);
        break;
      case "KML":
      case "GEOJSON":
        window.MAIN_CESIUM_VIEWER.dataSources.remove(asset);
        break;
      default:
        break;
    }

    delete window.assets[id];
  }

  const changeVisibilities = (item) => {
    var newVis = [...visibilities];
    const item_id = item.type === 'MATTERPORT' ? item.url : item.assetID ? item.assetID : item.ID;
    if (!newVis.includes(item_id)) newVis.push(item_id);
    if (window.assets[item_id] !== undefined && window.assets[item_id].show === false)
      newVis = newVis.filter(id => id !== item_id);

    Object.keys(window.assets)
      .filter(id => window.assets[id].type === "TERRAIN" && window.assets[id] !== window.assets[item_id])
      .forEach(id => {
        window.assets[id].show = false;
        const index = newVis.indexOf(id);
        if (index > -1) {
          newVis.splice(index, 1);
        }
      });

    setVisibilities(newVis);
  }

  const getWMTSCapabilities = async (url) => {
    try {
      let serviceUrl = url;
      let urlObj = new URL(serviceUrl, window.location.origin);
      urlObj.searchParams.set('SERVICE', 'WMTS');
      urlObj.searchParams.set('REQUEST', 'GetCapabilities');
      urlObj.searchParams.set('VERSION', '1.0.0');

      const response = await fetch(urlObj.toString());
      if (response.ok) {
        const text = await response.text();
        const parser = new DOMParser();
        const xml = parser.parseFromString(text, "application/xml");

        const contents = xml.getElementsByTagName("Contents")[0];
        if (!contents) {
          showAlert('info', 'This WMTS service does not have a Contents element.');
          return null;
        }
        
        const layers = contents.getElementsByTagName("Layer");
        if (!layers.length) {
          showAlert('info', 'There are no layers in this WMTS service.');
          return null;
        }
        const layer = layers[0];

        const identifierTag = layer.getElementsByTagName("ows:Identifier")[0] || layer.getElementsByTagName("Identifier")[0];
        const layerName = identifierTag ? identifierTag.textContent : null;

        let tmsName = null;
        const tmsLinks = layer.getElementsByTagName("TileMatrixSetLink");
        if (tmsLinks.length) {
          const tmsIdentifierTag = tmsLinks[0].getElementsByTagName("TileMatrixSet")[0];
          tmsName = tmsIdentifierTag ? tmsIdentifierTag.textContent : null;
        } else {
          const tmsTags = contents.getElementsByTagName("TileMatrixSet");
          if (tmsTags.length) {
            const tmsIdentifier = tmsTags[0].getElementsByTagName("ows:Identifier")[0] || tmsTags[0].getElementsByTagName("Identifier")[0];
            tmsName = tmsIdentifier ? tmsIdentifier.textContent : null;
          }
        }

        if (tmsName) {
          let tileMatrixSetElement = null;
          const tmsTags = contents.getElementsByTagName("TileMatrixSet");
          for (let i = 0; i < tmsTags.length; ++i) {
            const tmsIdentifier = tmsTags[i].getElementsByTagName("ows:Identifier")[0] || tmsTags[i].getElementsByTagName("Identifier")[0];
            if (tmsIdentifier && tmsIdentifier.textContent === tmsName) {
              tileMatrixSetElement = tmsTags[i];
              break;
            }
          }
          
          if (!tileMatrixSetElement) {
            const allTmsTags = xml.getElementsByTagName("TileMatrixSet");
            for (let i = 0; i < allTmsTags.length; ++i) {
              const tmsIdentifier = allTmsTags[i].getElementsByTagName("ows:Identifier")[0] || allTmsTags[i].getElementsByTagName("Identifier")[0];
              if (tmsIdentifier && tmsIdentifier.textContent === tmsName) {
                tileMatrixSetElement = allTmsTags[i];
                break;
              }
            }
          }
        }

        let getTileEndpoint = null;
        const resourceURLs = layer.getElementsByTagName("ResourceURL");
        for (let i = 0; i < resourceURLs.length; ++i) {
          const el = resourceURLs[i];
          const resourceType = el.getAttribute("resourceType");
          if (resourceType === "tile" && el.getAttribute("template")) {
            getTileEndpoint = el.getAttribute("template");
            break;
          }
        }
        
        if (!getTileEndpoint) {
          const globalResourceURLs = contents.getElementsByTagName("ResourceURL");
          for (let i = 0; i < globalResourceURLs.length; ++i) {
            const el = globalResourceURLs[i];
            const resourceType = el.getAttribute("resourceType");
            if (resourceType === "tile" && el.getAttribute("template")) {
              getTileEndpoint = el.getAttribute("template");
              break;
            }
          }
        }

        if (!getTileEndpoint) {
          const operations = xml.getElementsByTagName("ows:OperationsMetadata")[0] || xml.getElementsByTagName("OperationsMetadata")[0];
          if (operations) {
            const operationTags = operations.getElementsByTagName("ows:Operation");
            for (let i = 0; i < operationTags.length; ++i) {
              const op = operationTags[i];
              if (op.getAttribute("name") === "GetTile") {
                const dcp = op.getElementsByTagName("ows:DCP")[0] || op.getElementsByTagName("DCP")[0];
                if (dcp) {
                  const http = dcp.getElementsByTagName("ows:HTTP")[0] || dcp.getElementsByTagName("HTTP")[0];
                  if (http) {
                    const get = http.getElementsByTagName("ows:Get")[0] || http.getElementsByTagName("Get")[0];
                    if (get) {
                      getTileEndpoint = get.getAttribute("xlink:href") || get.getAttribute("href");
                      break;
                    }
                  }
                }
              }
            }
          }
        }

        if (!layerName) {
          showAlert('info', 'Could not find a valid layer identifier in this WMTS service.');
          return null;
        }

        if (!tmsName) {
          showAlert('info', 'Could not find a default TileMatrixSet in this WMTS service.');
          return null;
        }

        if (!getTileEndpoint) {
          showAlert('info', 'Could not find a GetTile endpoint in this WMTS service.');
          return null;
        }

        return { layer: layerName, tileMatrixSet: tmsName, getTileEndpoint };
      }
    } catch (e) {
      showAlert('error', 'Failed to retrieve or parse WMTS GetCapabilities');
      return null;
    }
  }

  const getWMSCapabilities = async (url) => {
    try {
      let serviceUrl = url;
      let urlObj = new URL(serviceUrl, window.location.origin);
      urlObj.searchParams.set('service', 'WMS');
      urlObj.searchParams.set('request', 'GetCapabilities');
      urlObj.searchParams.set('version', '1.1.1');

      const response = await fetch(urlObj.toString());
      if (response.ok) {
        const text = await response.text();
        const parser = new DOMParser();
        const xml = parser.parseFromString(text, "application/xml");
        const layers = Array.from(xml.getElementsByTagName("Layer"));
        let availableLayers = layers.map(layer => {
          const nameTag = layer.getElementsByTagName("Name")[0];
          const titleTag = layer.getElementsByTagName("Title")[0];
          if (nameTag && nameTag.textContent) {
            return {
              name: nameTag.textContent,
              title: titleTag ? titleTag.textContent : ''
            };
          }
          return null;
        }).filter(Boolean);
        
        if (availableLayers.length > 0) return availableLayers[0].name;
        
        showAlert('info', 'There are no layers in this service.');
        return null;
      }
    } catch (e) {
      showAlert('error', 'Failed to retrieve or parse WMS GetCapabilities');
      return null;
    }
  }

  const loadAssetFromCesiumIon = async (item) => {
    if (item.type === "3DTILES") {
      Cesium.IonResource.fromAssetId(item.assetID, { accessToken: item.tokenKey }).then((resource) => {
        Cesium.Cesium3DTileset.fromUrl(resource).then(tileset => {
          window.assets[item.assetID] = tileset;
          window.assets[item.assetID].type = "3DTILES";
          window.MAIN_CESIUM_VIEWER.scene.primitives.add(tileset);
          window.MAIN_CESIUM_VIEWER.flyTo(tileset);
          changeVisibilities(item);
        });
      }).catch(() => {
        showAlert('error', 'Failed to retrieve the 3D Tileset Resource from Cesium Ion.')
      });
    } else if (item.type === "IMAGERY") {
      Cesium.IonImageryProvider.fromAssetId(parseInt(item.assetID), { accessToken: item.TokenKey }).then(resource => {
        const imageLayer = window.MAIN_CESIUM_VIEWER.imageryLayers.addImageryProvider(resource, 1);
        window.assets[item.assetID] = imageLayer;
        window.assets[item.assetID].type = "IMAGERY";
        changeVisibilities(item);
      }).catch(() => {
        showAlert('error', 'Failed to retrieve the Imagery Resource from Cesium Ion.')
      });
    } else if (item.type === "TERRAIN") {
      Cesium.IonResource.fromAssetId(item.assetID, { accessToken: item.tokenKey }).then(resource => {
        Cesium.CesiumTerrainProvider.fromUrl(resource).then(terrain => {
          window.MAIN_CESIUM_VIEWER.terrainProvider = terrain;
          window.assets[item.assetID] = terrain;
          window.assets[item.assetID].type = "TERRAIN";
          window.assets[item.assetID].show = true;
          changeVisibilities(item);
        });
      }).catch(() => {
        showAlert('error', 'Failed to retrieve the Terrain Resource from Cesium Ion.');
      });
    } else if (item.type === "GLTF") {
      Cesium.IonResource.fromAssetId(item.assetID, { accessToken: item.tokenKey }).then((resource) => {
        window.assets[item.assetID] = window.MAIN_CESIUM_VIEWER.entities.add({
          position: Cesium.Cartesian3.fromDegrees(0, 0, 100),
          model: { uri: resource },
        });
        window.assets[item.assetID].type = "GLTF";
        window.MAIN_CESIUM_VIEWER.flyTo(window.assets[item.assetID]);
        changeVisibilities(item);
      }).catch(() => {
        showAlert('error', 'Failed to retrieve the 3D Model Resource from Cesium Ion.');
      });
    } else if (item.type === "KML") {
      window.assets[item.assetID] = Cesium.IonResource.fromAssetId(item.assetID, { accessToken: item.tokenKey }).then((resource) => {
        return Cesium.KmlDataSource.load(resource, {
          camera: window.MAIN_CESIUM_VIEWER.scene.camera,
          canvas: window.MAIN_CESIUM_VIEWER.scene.canvas,
        });
      }).then((dataSource) => {
        window.assets[item.assetID] = dataSource
        window.assets[item.assetID].type = "KML";
        window.MAIN_CESIUM_VIEWER.dataSources.add(dataSource);
        window.MAIN_CESIUM_VIEWER.flyTo(window.assets[item.assetID]);
        changeVisibilities(item);
      }).catch(() => {
        showAlert('error', 'Failed to retrieve the KML Resource from Cesium Ion.');
      });
    } else if (item.type === "GEOJSON") {
      window.assets[item.assetID] = Cesium.IonResource.fromAssetId(item.assetID, { accessToken: item.tokenKey }).then((resource) => {
        return Cesium.GeoJsonDataSource.load(resource);
      }).then((dataSource) => {
        window.assets[item.assetID] = dataSource
        window.assets[item.assetID].type = "GEOJSON";
        window.MAIN_CESIUM_VIEWER.dataSources.add(dataSource);
        window.MAIN_CESIUM_VIEWER.flyTo(window.assets[item.assetID]);
        changeVisibilities(item);
      }).catch(() => {
        showAlert('error', 'Failed to retrieve the GeoJSON Resource from Cesium Ion.');
      });
    } else if (item.type === 'WMS') {
      item.url = item.url.replace('http:', 'https:');
      getWMSCapabilities(item.url).then((layer_name) => {
        const imageryProvider = new Cesium.WebMapServiceImageryProvider({
          url: item.url,
          layers: layer_name,
          parameters: {
            service: "WMS",
            version: "1.1.1",
            transparent: true,
            format: "image/png"
          }
        });

        const imageLayer = window.MAIN_CESIUM_VIEWER.imageryLayers.addImageryProvider(imageryProvider, 1);
        window.assets[item.ID] = imageLayer;
        window.assets[item.ID].type = item.type;
        changeVisibilities(item);
      }).catch(() => showAlert('error', 'Failed to load the WMS service.'));
    } else if (item.type === "WMTS") {
      item.url = item.url.replace('http:', 'https:');
      getWMTSCapabilities(item.url).then((capabilities) => {
        const imageryProvider = new Cesium.WebMapTileServiceImageryProvider({
          url: capabilities.getTileEndpoint,
          layer: capabilities.layer,
          style: 'default',
          format: 'image/png',
          tileMatrixSetID: capabilities.tileMatrixSet,
        });

        const imageLayer = window.MAIN_CESIUM_VIEWER.imageryLayers.addImageryProvider(imageryProvider, 1);
        window.assets[item.ID] = imageLayer;
        window.assets[item.ID].type = item.type;
        changeVisibilities(item);
      }).catch(() => showAlert('error', 'Failed to load the WMTS service.'));
    } else if (item.type === "TMS") {
      item.url = item.url.replace('http:', 'https:');
      const imageryProvider = new Cesium.UrlTemplateImageryProvider({
        url: item.url,
        tilingScheme: new Cesium.WebMercatorTilingScheme(),
      });

      const imageLayer = window.MAIN_CESIUM_VIEWER.imageryLayers.addImageryProvider(imageryProvider, 1);
      window.assets[item.ID] = imageLayer;
      window.assets[item.ID].type = item.type;
      changeVisibilities(item);
    }
  }

  const loadAsset = (item) => {
    if (item.type === "MATTERPORT") {
      var iframeElem = document.getElementById("matterport-iframe");
      iframeElem.src = item.url;
      iframeElem.style.display = "block";
      window.assets[item.url] = { show: true }
      changeVisibilities(item);
    } else {
      if (!window.assets) window.assets = {};
      loadAssetFromCesiumIon(item);
    }
  }

  const onChangeVisible = (item) => {
    let item_id = item.assetID ? item.assetID : item.ID;
    if (item.type === "MATTERPORT") {
      var iframeElem = document.getElementById("matterport-iframe");
      if (iframeElem.src === item.url) {
        iframeElem.src = null;
        iframeElem.style.display = "none";
        window.assets[item.url] = { show: false }
      } else {
        iframeElem.src = item.url;
        iframeElem.style.display = "block";
        window.assets[item.url] = { show: true }
      }
      changeVisibilities(item);
    } else {
      if (window.assets && window.assets[item_id]) {
        window.assets[item_id].show = !window.assets[item_id].show;
        if (item.type === "TERRAIN")
          window.MAIN_CESIUM_VIEWER.terrainProvider = window.assets[item_id].show ? window.assets[item_id] : new Cesium.EllipsoidTerrainProvider();

        if (window.assets[item_id].show)
          if (item.type === "3DTILES" || item.type === "GLTF" || item.type === "KML" || item.type === "GEOJSON")
            window.MAIN_CESIUM_VIEWER.flyTo(window.assets[item_id]);

        changeVisibilities(item);
      } else {
        loadAsset(item);
      }
    }
  }

  const deleteAsset = (asset) => {
    deleteProjectAsset(asset.ID).then(() => {
      if (asset.type !== "MATTERPORT") {
        var iframeElem = document.getElementById("matterport-iframe");
        if (iframeElem.src === asset.url) {
          iframeElem.src = null;
          iframeElem.style.display = "none";
          window.assets[asset.url] = { show: false }
          changeVisibilities(asset);
        }
      } else {
        removeItem(asset.assetID ? asset.assetID : asset.ID);
      }
      showAlert('success', 'Item has been successfully removed.');
      getAssets();
    })
  }

  const handleEdit = (asset) => {
    dispatch({ type: 'SET_SELECTED_ION_ASSET', selectedIonAsset: asset });
    onEdit();
  }

  return (
    <Accordion open sort heading="Assets" id="assets-accordion">
      {!assets || assets.length === 0 ? (
        <AddAssetsBtn onClick={onAdd}>
          <CloudUploadOutlined />
          Add Site Data
        </AddAssetsBtn>
      ) :
        assets.map((asset, index) => {
          return (
            <AccordionItem
              visibility={asset.type === "MATTERPORT" ? !visibilities.includes(asset.url) : !visibilities.includes(asset.assetID ? asset.assetID : asset.ID)}
              key={asset.assetID ? asset.assetID : asset.ID}
              icon={icons[asset.type]}
              label={asset.name}
              onClick={() => onChangeVisible(asset)}
              onDelete={() => { deleteAsset(asset) }}
              onEdit={() => { handleEdit(asset) }}
              type="asset"
              onChangeVisible={() => { onChangeVisible(asset) }}
              description={asset.description}
            />)
        })
      }
    </Accordion>
  );
};

export default Assets;